import AbstractForecastColumn from "./AbstractForecastColumn.js";

/**
 * This column is used to handle the existing data on the previous periods in
 * the forecasting table. It must always be visible even if there is no data.
 */
export default class ReferenceForecastColumn extends AbstractForecastColumn {
	accept(visitor) {
		return visitor.visitReferenceForecastColumn(this);
	}

	isReferenceForecastColumn() {
		return true;
	}
}
